// assets
import { IconMail, IconList } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconMailTemplate: IconMail,
  IconMailTemplateList: IconList
};

// ==============================|| MENU ITEMS - MAIL TEMPLATE ||============================== //

const mailTemplate: NavItemType = {
  id: 'mail-template',
  title: 'Mail Templates',
  type: 'group',
  icon: icons.IconMailTemplate,
  children: [
    {
      id: 'mail-template-list',
      title: 'All Templates',
      type: 'item',
      url: '/mail-template/list',
      icon: icons.IconMailTemplateList,
      breadcrumbs: false
    }
  ]
};

export default mailTemplate;